module.exports = __webpack_public_path__ + "img/zhi2.913b2d8f.jpg";